import { EnvironmentConfig } from '@shared/models/environment-config.model';

export let CONFIG: EnvironmentConfig = {} as EnvironmentConfig;

export const setConfig = (config) => {
  CONFIG = config;
};
